import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=9ff2753a&"
import script from "./InvoiceCard.vue?vue&type=script&lang=ts&"
export * from "./InvoiceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports